import { db } from "./db";
import { categoriesSeed, productsSeed, productCategoriesSeed } from "./seed-data";

export async function syncDatabase() {
  console.log("Starting database synchronization from seed data...");
  try {
    // Clear existing to avoid duplicate conflicts and stale items
    await db.categories.clear();
    await db.products.clear();
    await db.product_categories.clear();

    // Sync Categories
    await db.categories.bulkPut(categoriesSeed as any);

    // Sync Products
    await db.products.bulkPut(productsSeed as any);

    // Sync Product Categories
    await db.product_categories.bulkPut(productCategoriesSeed as any);

    // We leave inquiries and inquiry_items alone since those are user-generated

    console.log("Database synchronization from seed completed successfully.");
  } catch (error) {
    console.error("Error during database synchronization:", error);
  }
}
